import {AuthContextType} from "../../types/types";
import {EnvironmentRegistry} from "../registry/environmentRegistry";
import axios, {AxiosResponse} from "axios";

export async function get<T=any>(endPoint: string, authContext: AuthContextType): Promise<AxiosResponse<T>> {
    const url = EnvironmentRegistry.getUrlFromContext(authContext);
    return axios.get(url + endPoint, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
}